var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Auth'),_c('Navbar'),_c('v-main',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('Footer'),_c('HelpMenu'),_c('Feedback'),_c('Toasts',{attrs:{"text":_vm.message,"color":"success"}}),_c('Toasts',{attrs:{"text":_vm.error,"color":"red","timeout":-1}}),_c('BasicToasts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }